import React, { createContext, useState } from 'react'

export const MainContext = createContext()

const MainContextProvider = (props) => {
  const [mode, setMode] = useState('select') // one of 'select', 'mode'
  const [needToTrackFace, setNeedToTrackFace] = useState(undefined)
  const [isLoading, setLoading] = useState(true)

  return (
    <MainContext.Provider
      value={{
        mode,
        setMode,
        needToTrackFace,
        setNeedToTrackFace,
        isLoading,
        setLoading
      }}
    >
      {props.children}
    </MainContext.Provider>
  )
}

export default MainContextProvider
